<template>
  <template v-if="!searchValue">
    {{ props.text }}
  </template>
  <span
    v-for="(element, index) of elements"
    v-else
    :key="index"
    :class="[element.className]"
  >
    {{ element.partialString }}
  </span>
</template>
<script lang="ts" setup>
import { ref, watch } from 'vue';
import useTextSearch from './useTextSearch';

const props = defineProps<{
  text: string;
  searchValue?: string;
  className: string;
}>();

const { highlightWordsInText } = useTextSearch();
const elements = ref<
  {
    partialString: string;
    className: string;
  }[]
>([]);
watch(
  props,
  () => {
    if (props.searchValue) {
      elements.value = highlightWordsInText(
        props.text,
        props.searchValue.trim(),
        props.className,
      );
    }
  },
  { immediate: true },
);
</script>
